import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-eef31e06"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "contact-form",
    class: "contact"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "contact-shape",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_3 = { class: "site-container contact-grid" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<p class=\"section-kicker\" data-v-eef31e06>Contacto</p><h2 data-v-eef31e06>¿Qué necesitás resolver?</h2><p class=\"contact-lead\" data-v-eef31e06> Mandame los datos básicos de tu consulta. El formulario llega directamente al email del estudio y te responderé a la brevedad. </p><div class=\"contact-methods\" data-v-eef31e06><a href=\"tel:+59899943824\" data-v-eef31e06><span data-v-eef31e06>Teléfono</span><strong data-v-eef31e06>+598 99 943 824</strong></a><a href=\"mailto:maryiglesiassosa@gmail.com\" data-v-eef31e06><span data-v-eef31e06>Email</span><strong data-v-eef31e06>maryiglesiassosa@gmail.com</strong></a></div>", 4);
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "Estudio en Montevideo"),
    /*#__PURE__*/ _createElementVNode("strong", null, "Bulevar España 2059, apto. 104"),
    /*#__PURE__*/ _createElementVNode("small", null, "Esquina Blanes")
], -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M12 21s6-5.1 6-11a6 6 0 1 0-12 0c0 5.9 6 11 6 11Z",
        stroke: "currentColor",
        "stroke-width": "1.5"
    }),
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "12",
        cy: "10",
        r: "2",
        stroke: "currentColor",
        "stroke-width": "1.5"
    })
], -1));
const _hoisted_10 = [
    _hoisted_8,
    _hoisted_9
];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    class: "whatsapp-link",
    href: "https://wa.me/59899943824",
    target: "_blank",
    rel: "noopener noreferrer"
}, [
    /*#__PURE__*/ _createTextVNode(" También podés escribir por WhatsApp "),
    /*#__PURE__*/ _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M5 12h14m-5-5 5 5-5 5",
            stroke: "currentColor",
            "stroke-width": "1.7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ])
], -1));
const _hoisted_12 = { class: "form-panel" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "form-heading" }, [
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Consulta por email"),
        /*#__PURE__*/ _createElementVNode("h3", null, "Escribime")
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "email-badge" }, [
        /*#__PURE__*/ _createElementVNode("i"),
        /*#__PURE__*/ _createTextVNode(" Envío directo ")
    ])
], -1));
import ContactForm from '@/components/ContactForm.vue';
const mapUrl = 'https://www.google.com/maps/search/?api=1&query=Bulevar+Espa%C3%B1a+2059%2C+Montevideo%2C+Uruguay';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContactSection',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", { class: "contact-info" }, [
                        _hoisted_4,
                        _createElementVNode("a", {
                            class: "location-card",
                            href: mapUrl,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, _hoisted_10),
                        _hoisted_11
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(ContactForm)
                    ])
                ])
            ]));
        };
    }
});
